<section
  #toast
  class="cookie-toast"
  *ngIf="consent.showToast"
  role="region"
  [attr.aria-label]="'cookie.toastTitle' | translate"
  [style.bottom.px]="toastBottom || null"
>
  <div class="cookie__intro">
    <div class="cookie__text">
      <p class="cookie__title">{{ "cookie.toastTitle" | translate }}</p>
      <p class="cookie__desc">
        {{ "cookie.toastDesc" | translate }}
        <br /><br />
        {{ "cookie.toastReadOur" | translate }}
        <a class="cookie__link" [href]="policyUrl" target="_blank" rel="noopener">{{
          "cookie.cookiePolicy" | translate
        }}</a>
        {{ "cookie.toastLearnMore" | translate }}
      </p>
    </div>
    <img class="cookie__mascot" [src]="mascotSrc" alt="" />
  </div>

  <div class="cookie-toast__actions">
    <button class="cookie__btn cookie__btn--outline" type="button" (click)="decline()">
      {{ "cookie.decline" | translate }}
    </button>
    <button class="cookie__btn cookie__btn--filled" type="button" (click)="accept()">
      {{ "cookie.accept" | translate }}
    </button>
  </div>
</section>

<div class="cookie-backdrop" *ngIf="consent.showSettings" (click)="closeSettings()">
  <section
    class="cookie-settings"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cookie-settings-title"
    [style.transform]="dragOffset ? 'translateY(' + dragOffset + 'px)' : null"
    (click)="$event.stopPropagation()"
    (touchstart)="onDragStart($event)"
    (touchmove)="onDragMove($event)"
    (touchend)="onDragEnd()"
  >
    <div class="cookie__intro">
      <div class="cookie__text">
        <p id="cookie-settings-title" class="cookie__title">
          {{ "cookie.settingsTitle" | translate }}
        </p>
        <p class="cookie__desc">{{ "cookie.settingsDesc" | translate }}</p>
      </div>
      <img class="cookie__mascot cookie__mascot--small" [src]="mascotSrc" alt="" />
    </div>

    <div class="cookie-settings__card">
      <div>
        <div class="cookie-settings__name">{{ "cookie.analyticsName" | translate }}</div>
        <div class="cookie-settings__desc">{{ "cookie.analyticsDesc" | translate }}</div>
      </div>
      <button
        class="cookie-switch"
        [class.cookie-switch--on]="analyticsOn"
        type="button"
        role="switch"
        [attr.aria-checked]="analyticsOn"
        [attr.aria-label]="'cookie.analyticsName' | translate"
        (click)="toggleAnalytics()"
      >
        <span class="cookie-switch__thumb"></span>
      </button>
    </div>

    <p class="cookie-settings__footnote">
      {{ "cookie.footnote" | translate }}
      <a class="cookie__link" [href]="policyUrl" target="_blank" rel="noopener">{{
        "cookie.privacyPolicy" | translate
      }}</a>
    </p>

    <button
      class="cookie__btn cookie__btn--filled cookie__btn--save"
      type="button"
      (click)="saveSettings()"
    >
      {{ "cookie.save" | translate }}
    </button>
  </section>
</div>
